module.exports = __webpack_public_path__ + "static/media/p_17_1.6a301cd7.png";